// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__24Qlb","options":"AnswerScale_options__1HKKa","selected":"AnswerScale_selected__1uNgy"};